// extracted by mini-css-extract-plugin
export default {"segmented-control":"eyxah","segmented-control_withPointer":"WvBZ8","segmented-control_pointerMovable":"nsvEy"};